import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Box } from '@mui/material';

const LoadingSkeleton = ({ headerHeight = 170 }) => {
    // Matches the loaded calendar: its toolbar row (~50px) plus calc(100vh - headerHeight), min 550px.
    return (
        <Box className="scheduler-loading-skeleton" sx={{ width: 'auto', height: `calc(100vh - ${headerHeight - 50}px)`, minHeight: '600px', m: 1.25, display: 'flex', flexDirection: 'column' }} >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.25 }}>
                <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                    <Skeleton variant="rounded" animation="wave" width={200} height={40} />
                    <Skeleton variant="rounded" animation="wave" width={300} height={40} />
                </Box>
                <Skeleton variant="rounded" animation="wave" width={160} height={40} />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.25 }}>
                <Skeleton variant="rounded" animation="wave" width={205} height={35} />
                <Skeleton variant="rectangular" animation="wave" width={100} height={35} />
                <Skeleton variant="rounded" animation="wave" width={295} height={35} />
            </Box>
            <Skeleton className="scheduler-loading-calendar" variant="rectangular" animation="wave" sx={{ flex: 1, minHeight: 0, height: 'auto' }} />
        </Box>
    )
}

export default LoadingSkeleton;